import React from "react";
import {Columns, Heading, Table} from "react-bulma-components";
import InspectionApproveRow from "./InspectionApproveRow";



export default function InspectionApproveSection({data, onChange}){

    return (
        <div>
            <Columns>
                <Columns.Column>
                    <Heading>Inspections</Heading>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table size={"fullwidth"}>
                        <thead>
                            <tr>
                                <th>Inspection Type</th>
                                <th>Expiry Date</th>
                                <th>Completed Date</th>
                                <th>Nex Expiry Date</th>
                                <th>New Completed Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.attached_inspections.map((inspection, index) => (
                                <InspectionApproveRow
                                    inspection={inspection}
                                    index={index}
                                    onChange={onChange}
                                />
                            ))}
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    )


}